import { gql, TypedDocumentNode, useQuery } from '@apollo/client';
import { Nullable } from '@e2m-customer-portal/shared';
import {
  SalesPartner,
  SalesPartnerGroup,
  SalesPartnerQuery,
  SalesPartnerQueryVariables,
  SalesPartnersQuery,
  SalesPartnersQueryVariables,
} from '../../generated/graphql';

export type { SalesPartnerGroup } from '../../generated/graphql';

export const salesPartnerQuery: TypedDocumentNode<SalesPartnerQuery, SalesPartnerQueryVariables> = gql`
  query SalesPartner {
    salesPartnerGroup {
      id
      name
      isConfigured
      permissions {
        id
        permissionId
        granted
      }
    }
  }
`;

export const salesPartnersQuery: TypedDocumentNode<SalesPartnersQuery, SalesPartnersQueryVariables> = gql`
  query SalesPartners {
    salesPartners {
      id
      name
      permissions {
        id
        permissionId
        granted
      }
      assignedMarketLocations {
        id
        name
        externalName
      }
      contractPartnerNumber
      isConfigured
    }
  }
`;

export function useSalesPartner(): Nullable<SalesPartnerGroup> {
  const { data } = useQuery(salesPartnerQuery, {});
  return data?.salesPartnerGroup;
}

export function useSalesPartners(): readonly SalesPartner[] | undefined {
  const { data } = useQuery(salesPartnersQuery, {});
  return data?.salesPartners;
}
